<script>
    export let label = '';
    export let action = () => {};
    export let disabled = false;
</script>

<style>
    .dropdown-item.disabled {
        pointer-events: none;
    }
</style>

<a
        class="dropdown-item"
        class:disabled
        on:mousedown={action}
        href="#">{label}</a>
